/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youtube_Export_HintInputs */

const cs_youtube_export_hint = /** @type {(inputs: Youtube_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrajte video nemovitosti přímo na propojený YouTube kanál. Odkaz se automaticky uloží u této nabídky.`)
};

const en_youtube_export_hint = /** @type {(inputs: Youtube_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload a property video directly to your linked YouTube channel. The watch link is saved on this listing automatically.`)
};

/**
* | output |
* | --- |
* | "Upload a property video directly to your linked YouTube channel. The watch link is saved on this listing automatically." |
*
* @param {Youtube_Export_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_hint = /** @type {((inputs?: Youtube_Export_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_hint(inputs)
	return cs_youtube_export_hint(inputs)
});